module.exports = "/static/assets/b8e9e92550d13ba932f978cb32d48c25.gif";